import { createClient, STRATEGIES } from "@lmn/brg-ui-tracking";
import { HEADER_NAME_MPT } from "@lmn/nextjs-appfw/dist/common";
import { EnvConfig } from "../Helpers/getServerConfig";
import { shouldTrack } from "@/lib/Helpers/trackingGate";

const externalRestServices = {
  sendStartrack: "/service/track/v1/events",
  sendARP: "/service/track/v2/events",
};

export function sendTrackWayEventsViaBrg(
  payload: any,
  trackway: any,
  mpt?: string,
  envConfig?: EnvConfig,
  channelOverride?: string
) {
  const { shouldTrackStartrack } = shouldTrack({ envConfig: envConfig ?? null });

  if (!shouldTrackStartrack) {
    console.log("sendTrackWayEventsViaBrg", payload, { mpt });
    return;
  }

  const clientConfig: any = {
    endpoint: externalRestServices.sendStartrack,
    channel: channelOverride ?? trackway?.startrackAppName,
  };

  // Add MPT header if available (depending on BRG client support)
  if (mpt) {
    clientConfig.headers = {
      [HEADER_NAME_MPT]: mpt,
    };
  }

  const client = createClient(STRATEGIES.HTTP, clientConfig);
  client.send(payload);
}
